<template>
  <div>
    <menu-pae :inFocus="false">
      <template>
        <div id="menuNovoProcesso">
          <div class="acoes">
            <button id="voltar" class="btn btn-danger" @click.prevent="voltar"> Voltar</button>
            <button id="salvar" class="btn btn-primary" @click.prevent="salvar"> Salvar</button>
          </div>
        </div>
      </template>
    </menu-pae>
    <div class="d-flex justify-content-center">
      <div class="row container">
        <div class="col-md-5 col-sm-12 text-sm-center">
          <nav aria-label="breadcrumb bg-white">
            <ol class="breadcrumb breadcrumb bg-white">
              <li class="breadcrumb-item">
                <router-link to="/workArea">Home</router-link>
              </li>
              <li class="breadcrumb-item">
                <router-link to="/elaboracao/consulta">Elaboração</router-link>
              </li>
              <li class="breadcrumb-item active" aria-current="page">{{ tipoMetodo }}</li>
            </ol>
          </nav>
        </div>
        <div class="col-md-7 col-sm-12 text-md-right text-sm-center" style="padding: 0.75rem 1rem;">
          <div id="numeroProcesso" class="form-row" v-show="tipoPersistencia!='NOVO'">
            <div id="protocolo" class="col">
              <span>
                <h5>
                  <span class="badge badge-primary">
                    Protocolo: <router-link id="link-visualizar-protocolo" class="text-white"
                                            :to="`/virtus/visualizadorProcesso?numeroProcesso=${numeroProcesso}${autocompletePath}`">
                      {{ formatarProtocolo(numeroProcesso) }}
                    </router-link>
                  </span>
                  <span v-show="tipoProtocolo == 'PROCESSO'" class="badge badge-primary ml-3">
                    Volume: <router-link id="link-visualizar-volume" class="text-white" :to="`/volume?numeroProcesso=${numeroProcesso}${autocompletePath}`">
                      {{ processo.volume }}
                    </router-link>
                  </span>
                </h5>
              </span>
              <span class="pl-3">
                Data Criação: <span class="font-weight-bold">{{ dataCriacao }}</span>
              </span>
              <span class="pl-3">
                Hora: <span class="font-weight-bold">{{ horaCriacao }}</span>
              </span>
            </div>
          </div>
        </div>
        <div class="col-12">
          <progressBar :progress="progresso" :success="progessColor.success" :warning="progessColor.warning"
                       class="mt-1 mb-3"/>
        </div>
      </div>
    </div>

    <div class="row">
      <alert-comp :key="alert.key" :msg="alert" />
      <div class="m-0 col-12" id="list-error">
        <div class="container">
          <div v-if="$v.processo.assunto.$error">
            <div class="form-group input-group" :class="{
              'form-group--error': $v.processo.assunto.$error
            }"></div>
            <div class="error mb-0">* É preciso selecionar um assunto</div>
          </div>
          <div v-if="$v.processo.especie.$error">
            <div class="form-group input-group" :class="{
              'form-group--error': $v.processo.especie.$error
            }"></div>
            <div class="error mb-0">* É preciso selecionar um tipo documental</div>
          </div>
          <div v-if="$v.interessadosResumo.$error">
            <div class="form-group input-group" :class="{
              'form-group--error': $v.interessadosResumo.$error
            }"></div>
            <div class="error mb-0">* É preciso de pelo menos um interessado para criar um protocolo</div>
          </div>
          <div v-if="$v.processo.complementoSetor.$error">
            <div class="form-group input-group" :class="{
              'form-group--error': $v.processo.complementoSetor.$error
            }"></div>
            <div class="error mb-0">* O campo informações complementares é obrigatório, o número máximo de caracteres
              dentro do complemento é de 300
            </div>
          </div>
          <div v-if="$v.documento.dataProducao.$error">
            <div class="form-group input-group" :class="{
              'form-group--error': $v.documento.dataProducao.$error
            }"></div>
            <div class="error mb-0">* É preciso inserir a data de produção do documento</div>
          </div>
          <div v-if="$v.documento.procedencia.$error">
            <div class="form-group input-group" :class="{
              'form-group--error': $v.documento.procedencia.$error
            }"></div>
            <div class="error mb-0">* É preciso inserir a procedência/origem do documento</div>
          </div>
          <div v-if="$v.documentoParams.pais.$error">
            <div class="form-group input-group" :class="{
              'form-group--error': $v.documentoParams.pais.$error
            }"></div>
            <div class="error mb-0">* É preciso inserir um pais para o documento</div>
          </div>
          <div v-if="$v.documentoParams.estado.$error">
            <div class="form-group input-group" :class="{
              'form-group--error': $v.documentoParams.estado.$error
            }"></div>
            <div class="error mb-0">* É preciso inserir um estado para o documento</div>
          </div>
          <div v-if="$v.documentoParams.cidade.$error">
            <div class="form-group input-group" :class="{
              'form-group--error': $v.documentoParams.cidade.$error
            }"></div>
            <div class="error mb-0">* É preciso inserir uma cidade para o documento</div>
          </div>
          <div v-if="$v.documento.procedencia.$error">
            <div class="form-group input-group" :class="{
              'form-group--error': $v.documento.procedencia.$error
            }"></div>
            <div class="error mb-0">* É preciso selecionar um tipo de documento</div>
          </div>
          <div v-if="$v.documento.documentoPermanente.$error">
            <div class="form-group input-group" :class="{
              'form-group--error': $v.documento.documentoPermanente.$error
            }"></div>
            <div class="error mb-0">* É preciso inserir a quantidade de documentos permanentes</div>
          </div>
        </div>
      </div>

      <div class="col-12">
        <div class="container mt-2">
          <hr class="bg-muted">
          <h5>Protocolo</h5>

          <div class="form-group row">
            <label for="" class="col-sm-2">Sigiloso:</label>
            <div class="col-sm-4">
              <div v-if="isTramitado || isSistemico" class="form-check form-check-inline">
                <label class="form-check-label" for="sigiloso-nao"> {{
                    processo.sigiloso === 'NAO' ? 'Não' : 'Sim'
                  }} </label>
              </div>
              <div v-if="!(isTramitado || isSistemico)" class="form-check form-check-inline">
                <input
                  class="form-check-input"
                  type="radio"
                  name="sigiloso"
                  value="NAO"
                  id="sigiloso-nao"
                  v-model="processo.sigiloso"
                  checked
                  v-if="!(isTramitado || isSistemico)"
                >
                <label class="form-check-label" for="sigiloso-nao">Não</label>
              </div>
              <div v-if="!(isTramitado || isSistemico)" class="form-check form-check-inline">
                <input
                  class="form-check-input"
                  type="radio"
                  name="sigiloso"
                  value="SIM"
                  id="sigiloso-sim"
                  v-model="processo.sigiloso"
                  checked
                  v-if="!(isTramitado || isSistemico)"
                >
                <label class="form-check-label" for="sigiloso-sim">Sim</label>
              </div>
            </div>

            <div class="col-sm-2">
              <label>Número de Anexos Vinculados:</label>
            </div>
            <div class="col-md-4 col-sm-10">
              <div v-if="isTramitado || isSistemico" class="form__input autocomplete w-100">
                <div v-if="processo.numeroAnexos  === '' ">
                  {{ processo.numeroAnexos = 0 }}
                </div>
                <div v-else>
                  {{ processo.numeroAnexos }}
                </div>
              </div>
              <div>
                <div class="form-group input-group" :class="{
                'form-group--error': $v.processo.numeroAnexos.$error
                }">
                  <input
                    id="numero-anexo"
                    v-if="!(isTramitado || isSistemico)"
                    type="number"
                    min="0"
                    value="0"
                    class="form-control"
                    v-model.trim="$v.processo.numeroAnexos.$model"
                    @input="onChangeNumeroDeAnexos()"
                    v-bind:disabled="isTramitado || isSistemico"
                  >
                </div>
                <div class="error" v-if="!$v.processo.numeroAnexos.lessThen">O Número de anexos vinculados só pode ser
                  maior ou igual a 0
                </div>
              </div>
            </div>

            <label for="" class="col-sm-2">Tipo Protocolo:</label>
            <div class="col-sm-4">
              <div v-if="(isTramitado || isSistemico) && tipoProtocolo === 'PROCESSO'" class="form__input autocomplete w-100">
                Processo
              </div>
              <div v-if="!(isTramitado || isSistemico) || tipoProtocolo === 'DOCUMENTO_AVULSO'">
                <div class="form-check form-check-inline" v-for="(item) in tiposProtocolo" :key="item.key">
                  <input class="form-check-input" type="radio" :name="`tipo-${item.key}`" :value="item.key"
                        :id="`tipo-${item.key}`" @change="onChangeTipoProtocolo" v-model="tipoProtocolo" checked>
                  <label class="form-check-label" :for="`tipo-${item.key}`">{{ item.value }}</label>
                </div>
              </div>
            </div>

            <label for="" class="col-sm-2">Documento:</label>
            <div class="col-sm-4">
              <div v-if="isTramitado || isSistemico" class="form__input autocomplete w-100">
                {{ processo.tipoDocumento }}
              </div>
              <div class="form-group input-group" v-if="!(isTramitado || isSistemico)">
                <div class="form-check form-check-inline" v-for="(item) in tiposDocumento" :key="item.key">
                  <input class="form-check-input" type="radio" :name="`tipo-${item.key}`" :value="item.key"
                        :id="`tipo-${item.key}`" @change="onChangeProcesso" v-model="processo.tipoDocumento" checked>
                  <label class="form-check-label" :for="`tipo-${item.key}`">{{ item.value }}</label>
                </div>
              </div>
            </div>

            <div class="col-sm-2">
              <label>Tipo documental: <span class="text-danger">*</span></label>
            </div>
            <div class="col-sm-10">
              <div v-if="autoCompleteIsBlocked" class="form-group input-group">
                {{ processo.especie ? processo.especie.especie : '' }}
              </div>
              <div>
                <div class="form-group input-group" :class="{
                'form-group--error': $v.processo.especie.$error
                }">
                  <auto-complete-comp
                    :isAsync="true"
                    :url="urlDadosFixosEspecie"
                    :marginTop="10"
                    mutation="MUT_ESPECIE"
                    keyAttrName="id"
                    valueAttrName="codigoEspecie especie"
                    :valor="processo.especie"
                    v-model="processo.especie"
                    :key="autoCompleteKey"
                    css="form__input autocomplete w-100"
                    :params="autoCompleteParamsEspecie"
                    :disabled="autoCompleteIsBlocked"
                    v-if="!autoCompleteIsBlocked"
                    @change="onChangeTipoDocumental"
                    id="autocomplete-especie"
                  >
                  </auto-complete-comp>
                </div>
                <div class="error" v-if="!$v.processo.especie.required">O campo é obrigatório</div>
              </div>
            </div>

            <div class="col-sm-2">
              <label>Código Assunto: <span class="text-danger">*</span></label>
            </div>
            <div :class="isTramitado || isSistemico ? 'col-sm-10' : 'col-md-4 col-sm-4'">
              <div class="form-group input-group autocomplete w-100">
                <input id="codigo-assunto" type="text" class="form-control disable" :value="assunto.codigoAssunto" readonly>
              </div>
            </div>

            <div class="col-sm-2">
              <label>Assunto: <span class="text-danger">*</span></label>
            </div>
            <div :class="isTramitado || isSistemico ? 'col-sm-10' : 'col-md-4 col-sm-10'">
              <div class="form-group input-group">
                <input id="assunto" type="text" class="form-control disable" :value="assunto.assunto" readonly>
              </div>
              <div class="error" v-if="!$v.processo.assunto.required">O campo é obrigatório</div>
            </div>

            <div class="col-sm-2" v-show="false">
              <button
                class="btn btn-outline-info"
                @click.prevent="$refs.modalName.openModal()"
                type="button"
                v-if="!(isTramitado || isSistemico)"
              >Interessados <span class="text-danger">*</span></button>
              <label v-if="isTramitado || isSistemico">
                Interessados:
              </label>
            </div>
            <div class="col-md-9 col-sm-10 mb-3" v-show="false">
              <div class="input-group" :class="{
                'form-group--error': $v.interessadosResumo.$error
              }">
                <textarea
                  id="interessado-resumo"
                  v-if="!(isTramitado || isSistemico)"
                  class="form-control"
                  v-model.trim="$v.interessadosResumo.$model"
                  disabled
                />
              </div>
              <div v-if="isTramitado || isSistemico" class="autocomplete w-100">
                {{ $v.interessadosResumo.$model }}
              </div>
              <div class="error mt-2" v-if="!$v.interessadosResumo.required">O campo é obrigatório</div>
            </div>

            <!-- Complemento -->
            <label for="" class="col-sm-2">Informações Complementares:<span class="text-danger">*</span></label>
            <div class="col-md-10 col-sm-10">
              <div v-if="isTramitado || isSistemico" class="form-group input-group">
                {{ processo.complementoSetor }}
              </div>
              <div class="form-group input-group" :class="{
                'form-group--error': $v.processo.complementoSetor.$error
              }">
                <textarea
                id="informacoes-complementares"
                  v-if="!(isTramitado || isSistemico)"
                  class="form-control"
                  rows="3"
                  v-model.trim="$v.processo.complementoSetor.$model"
                  @input="onChangeProcesso"
                />
              </div>
              <div class="error" v-if="!$v.processo.complementoSetor.required">O campo é obrigatório, quantidade máxima de
                300 caracteres.
              </div>
            </div>
          </div>
        </div>
      </div>

      <div id="dadosElaboracaoProcesso" class="form-row">
        <div class="col-md-2" v-show="false">
          <label>Tipo Processo</label>
        </div>
        <div class="col-md-10" v-show="false">
          <div class="form-check form-check-inline">
            <label class="mr-1" v-for="(item) in tipoProcesso" :key="item.key">
              <input type="radio"
                     class="form-check-input"
                     :value="item.key"
                     :checked="processo.tipoProcesso == item.key"
                     v-model="processo.tipoProcesso"
                     @change="onChangeProcesso"
                     id="tipo-processo">
              {{ item.value }}
            </label>
          </div>
        </div>
      </div>

      <div class="col-12" v-if="this.isNovo">
        <div class="container mt-2">
          <hr class="bg-muted">
          <h5 class="strong">Documento</h5>

          <div class="form-group row">
            <label for="" class="col-sm-2">Data de Produção do Documento/Processo:<span class="text-danger">*</span></label>
            <div class="col-md-10 col-sm-10">
              <div class="form-group input-group" :class="{
                'form-group--error': $v.documento.dataProducao.$error
              }">
                <input
                  type="date"
                  id="data-producao"
                  class="form-control"
                  rows="3"
                  v-model.trim="$v.documento.dataProducao.$model"
                  @input="onChangeProcesso"
                />
              </div>
              <div class="error" v-if="!$v.documento.dataProducao.required">O campo é obrigatório</div>
              <div class="error" v-if="!$v.documento.dataProducao.greaterThan">Data de produção do documento não pode ser maior que a data atual!</div>
            </div>

            <label for="" class="col-sm-2">Procedência/Origem:<span class="text-danger">*</span></label>
            <div class="col-md-4 col-sm-10">
              <div class="form-group input-group" :class="{
                'form-group--error': $v.documento.procedencia.$error
              }">
                <input
                  type="text"
                  id="procedencia-origem"
                  class="form-control"
                  rows="3"
                  v-model.trim="$v.documento.procedencia.$model"
                  @input="onChangeProcesso"
                />
              </div>
              <div class="error" v-if="!$v.documento.procedencia.required">O campo é obrigatório</div>
            </div>

            <div class="col-sm-2">
              <label>País: <span class="text-danger">*</span></label>
            </div>
            <div class="col-md-4 col-sm-10">
              <div>
                <div class="form-group input-group" :class="{
                'form-group--error': $v.documentoParams.pais.$error
                }">
                  <auto-complete-comp
                    :isAsync="true"
                    :url="documento.pais.url"
                    default="Brasil"
                    :marginTop="10"
                    mutation="MUT_PAIS"
                    keyAttrName="chave"
                    keyAttrFilter="descricao"
                    valueAttrName="descricao"
                    :valor="documento.pais.value"
                    v-model="documento.pais.value"
                    :key="autoCompleteKey"
                    css="form__input autocomplete w-100"
                    id="autocomplete-pais"
                  >
                  </auto-complete-comp>
                  <div class="error" v-if="!$v.documentoParams.pais.required">O campo é obrigatório</div>
                </div>
              </div>
            </div>

            <div v-if="documentoParams.estado.show" class="col-sm-2">
              <label>Estado: <span class="text-danger">*</span></label>
            </div>
            <div v-if="documentoParams.estado.show" class="col-md-4 col-sm-10" :key="documentoParams.estado.key">
              <div>
                <div class="form-group input-group" :class="{
                'form-group--error': $v.documentoParams.estado.$error
                }">
                  <auto-complete-comp
                    :isAsync="true"
                    :url="documento.estado.url"
                    :marginTop="10"
                    mutation="MUT_ESTADO"
                    keyAttrName="chave"
                    keyAttrFilter="descricao"
                    valueAttrName="descricao"
                    :valor="documento.estado.value"
                    v-model="documento.estado.value"
                    :key="autoCompleteKey"
                    css="form__input autocomplete w-100"
                    :params="documentoParams.estado"
                    id="autocomplete-estado"
                  >
                  </auto-complete-comp>
                </div>
                <div class="error" v-if="!$v.documentoParams.estado.required">O campo é obrigatório</div>
              </div>
            </div>

            <div v-if="documentoParams.cidade.show" class="col-sm-2">
              <label>Cidade: <span class="text-danger">*</span></label>
            </div>
            <div v-if="documentoParams.cidade.show" class="col-md-4 col-sm-10" :key="documentoParams.cidade.key">
              <div>
                <div class="form-group input-group" :class="{
                'form-group--error': $v.documentoParams.cidade.$error
                }">
                  <auto-complete-comp
                    :isAsync="true"
                    :url="documento.cidade.url"
                    :marginTop="10"
                    mutation="MUT_CIDADE"
                    keyAttrName="chave"
                    keyAttrFilter="descricao"
                    valueAttrName="descricao"
                    :valor="documento.cidade.value"
                    v-model="documento.cidade.value"
                    :key="autoCompleteKey"
                    css="form__input autocomplete w-100"
                    :params="documentoParams.cidade"
                    id="autocomplete-cidade"
                  >
                  </auto-complete-comp>
                </div>
                <div class="error" v-if="!$v.documentoParams.cidade.required">O campo é obrigatório</div>
              </div>
            </div>

            <label for="" class="col-sm-2">Tipo de Documento:<span class="text-danger">*</span></label>
            <div class="col-md-4 col-sm-10">
              <div class="form-group input-group" :class="{
                'form-group--error': $v.documento.tipoConferencia.$error
              }">
                <select class="form-control" id="tipoDocumentoConferencia" v-model.trim="$v.documento.tipoConferencia.$model">
                  <option v-for="item in tiposConferencia" :key="item.id" :id="item.id" :value="item.tipoConferencia">
                    {{ item.tipoConferencia }}
                  </option>
                </select>
              </div>
              <div class="error" v-if="!$v.documento.tipoConferencia.required">O campo é obrigatório</div>
            </div>

            <label for="" class="col-sm-2">Quantidade de Documentos Permanentes:<span class="text-danger">*</span></label>
            <div class="col-md-4 col-sm-10">
              <div class="form-group input-group" :class="{
                'form-group--error': $v.documento.documentoPermanente.$error
              }">
                <input
                  type="number"
                  id="quantidadeDocumentosPermanentes"
                  class="form-control"
                  v-model.trim="$v.documento.documentoPermanente.$model"
                />
              </div>
              <div class="error" v-if="!$v.documento.documentoPermanente.required">O campo é obrigatório</div>
            </div>

            <label for="" class="col-sm-2">Número do Documento:</label>
            <div class="col-md-4 col-sm-10">
              <div class="form-group input-group">
                <input
                  type="text"
                  id="numeroDoc"
                  class="form-control"
                  v-model.trim="documento.numeroDoc"
                />
              </div>
            </div>

            <label for="" class="col-sm-2">Ano:</label>
            <div class="col-md-4 col-sm-10">
              <div class="form-group input-group">
                <input
                  type="text"
                  id="anoDoc"
                  class="form-control"
                  v-model.trim="documento.anoDoc"
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-12">
        <div>
          <interessado :isTramitado="isTramitado || isSistemico"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import menuPae from '@/components/Menu.vue'
import autoCompleteComp from '@/components/autocomplete/AutoCompleteComp'
import interessado from '@/components/filtro-interessados/protocolo'
import progressBar from '@/components/progressBar/ProgressBar'
import alertComp from '@/components/alert/AlertComp'

import ProcessoElaboracaoService from '@/services/ProcessoElaboracaoService'
import DadosFixosService from '@/services/DadosFixosService'
import RecursoService from '@/services/RecursoService'

import { buscarProcesso, EDICAO, MODELO, NOVO, persistirProcesso, RESERVA } from '@/controllers/processo'
import { protocoloParse } from '@/uteis/converters/ProtocoloConverter'
import { componentIsVisible, rules } from '@/uteis/action/permissao'

import eventBus from '@/uteis/eventBus'

import { required } from 'vuelidate/lib/validators'
import { mapState } from 'vuex'

export default {
  name: 'elaboracao',

  components: {
    menuPae,
    interessado,
    autoCompleteComp,
    progressBar,
    alertComp
  },

  data () {
    return {
      choice: 'PROTOCOLO',
      isEdicao: false,
      numeroProcesso: '',
      dataCriacao: '',
      tipoProtocolo: 'DOCUMENTO_AVULSO',
      horaCriacao: '',
      processo: {
        tipoDocumento: '',
        sigiloso: '',
        nomeUsuario: '',
        assunto: {},
        especie: {},
        numeroAnexos: 0
      },
      documento: {
        dataProducao: '',
        procedencia: '',
        tipoConferencia: '',
        numeroDoc: '',
        anoDoc: '',
        documentoPermanente: null,
        pais: {
          value: {},
          url: '/d0593/pae-back/v1/recurso/build/paises'
        },
        estado: {
          value: {},
          url: '/d0593/pae-back/v1/recurso/build/estados'
        },
        cidade: {
          value: {},
          url: '/d0593/pae-back/v1/recurso/build/cidades'
        }
      },
      interessadosResumo: '',
      sigiloso: ['Sim', 'Nao'],
      eventBusModal: 'closeModal',
      tipoProcesso: [],
      urlDadosFixosAssunto: '/d0593/pae-back/v1/dadosFixos/assunto',
      // urlDadosFixosEspecie: '/d0593/pae-back/v1/dadosFixos/especie',
      autoCompleteParams: {},
      autoCompleteParamsEspecie: {},
      autoCompleteKey: true,
      tiposDocumento: [{
        value: 'Simples',
        key: 'SIMPLES'
      }, {
        value: 'Composto',
        key: 'COMPOSTO'
      }],
      tiposConferencia: [],
      alert: {
        type: '',
        texto: '',
        key: true
      }
    }
  },

  validations: {
    interessadosResumo: {
      required
    },
    documento: {
      dataProducao: {
        required: function (value) {
          return this.validateRequired(value)
        },
        greaterThan: function (value) {
          if (!this.isNovo) {
            return true
          }

          if (value === '' || !value) {
            return false
          }

          const timeDataProducao = new Date(value).getTime()
          const timeNow = new Date().getTime()
          if (timeDataProducao > timeNow) {
            return false
          }

          return true
        }
      },
      procedencia: {
        required: function (value) {
          return this.validateRequired(value)
        }
      },
      tipoConferencia: {
        required: function (value) {
          return this.validateRequired(value)
        }
      },
      documentoPermanente: {
        required: function (value) {
          return this.validateRequired(value)
        }
      }
    },
    documentoParams: {
      pais: {
        required: function () {
          const paisChave = this.documentoCadastro.paisChave
          return this.validateRequired(paisChave)
        }
      },
      estado: {
        required: function (value) {
          if (value.show) {
            const estadoChave = this.documentoCadastro.estadoChave
            return this.validateRequired(estadoChave)
          }
          return true
        }
      },
      cidade: {
        required: function (value) {
          if (value.show) {
            const cidadeChave = this.documentoCadastro.cidadeChave
            return this.validateRequired(cidadeChave)
          }
          return true
        }
      }
    },
    processo: {
      numeroAnexos: {
        lessThan (value) {
          return value === '' || value >= 0
        }
      },
      assunto: {
        required
      },
      especie: {
        requiredOnlyInElaboracao (value) {
          if (this.isTramitado || this.isSistemico) {
            return true
          }

          if (value === undefined || value.especie === undefined) {
            return false
          }

          return true
        },
        codigoEspecie: {
          requiredOnlyInElaboracao (value) {
            if (this.isTramitado || this.isSistemico) {
              return true
            }

            if (value === undefined) {
              return false
            }

            return true
          }
        }
      },
      complementoSetor: {
        required (value) {
          if (this.isTramitado || this.isSistemico) {
            return true
          }

          if (value === '') {
            return false
          }

          return value !== undefined
        },
        lessThen300Characters (value) {
          if (!value) {
            return true
          }

          if (value.length > 300) {
            return false
          }

          return true
        }
      }
    }
  },

  created () {
    this.processoElaboracaoService = new ProcessoElaboracaoService()
    this.dadosFixosService = new DadosFixosService()
    this.recursoService = new RecursoService()

    this.numeroProcesso = this.$route.query.numeroProcesso
    this.isTramitado = this.$route.query.tramitado === 'true'
    this.reserva = this.$route.query.reserva
    this.modelo = this.$route.query.modelo
    this.autoCompleteParams.idOrgao = this.$store.getters.getDadosSessao.sessao.idOrgao
    this.autoCompleteParamsEspecie.idOrgao = this.$store.getters.getDadosSessao.sessao.idOrgao
    this.isSistemico = false

    this.tipoPersistencia = this.reserva ? RESERVA : this.modelo ? MODELO : this.numeroProcesso ? EDICAO : NOVO
    this.tipoMetodo = this.tipoPersistencia === EDICAO ? 'Editar' : 'Novo'
    this.isNovo = this.tipoPersistencia === NOVO
    this.tipoProtocoloEdicao = ''

    buscarProcesso(this.tipoPersistencia, this.numeroProcesso)
      .then((processo) => {
        this.configurarProcesso(processo)
        this.isSistemico = processo.tipoProcesso === 'SISTEMICO'
        if (this.tipoPersistencia === EDICAO) {
          this.tipoProtocoloEdicao = processo.numeroProcesso.tipoProtocolo
        }
        this.autoCompleteKey = !this.autoCompleteKey
      })

    this.buscarTiposProcessos()
    this.buscarTiposConferencia()
  },

  computed: {
    autocompletePath () {
      let path = ''

      if (this.$route.query.disableMenuProcesso) {
        path += '&disableMenuProcesso=true'
      }

      if (this.$route.query.tramitado !== undefined) {
        path += `&tramitado=${this.$route.query.tramitado}`
      }

      return path
    },
    urlDadosFixosEspecie () {
      if (this.isTramitado && this.processo.assunto.assunto && (!this.processo.especie || !this.processo.especie.especie)) {
        return `/d0593/pae-back/v1/dadosFixos/assunto/${this.processo.idAssunto}/especies`
      }

      return '/d0593/pae-back/v1/dadosFixos/especie'
    },
    autoCompleteIsBlocked () {
      if (this.isSistemico) {
        return true
      }

      if (this.isTramitado && (this.processo.especie && this.processo.especie.especie)) {
        return true
      }

      return false
    },
    ...mapState({
      assuntoSelecionado: state => state.processoCadastro.assunto,
      especieSelecionada: state => state.processoCadastro.especie,
      codigoAssuntoSelecionado: state => state.processoCadastro.codigoAssunto,
      codigoEspecieSelecionada: state => state.processoCadastro.idEspecie,
      interessadosSelecionados: state => state.interessadosSelecionados,
      progresso (state) {
        const max = 11
        let count = 0
        count += this.$v.processo.especie.$invalid ? 0 : 1
        count += this.$v.processo.assunto.$invalid ? 0 : 1
        count += this.$v.processo.complementoSetor.$invalid ? 0 : 1
        count += this.$v.interessadosResumo.$invalid ? 0 : 1

        count += this.$v.documento.dataProducao.$invalid ? 0 : 1
        count += this.$v.documento.procedencia.$invalid ? 0 : 1
        count += this.$v.documentoParams.pais.$invalid ? 0 : 1
        count += this.$v.documentoParams.estado.$invalid ? 0 : 1
        count += this.$v.documentoParams.cidade.$invalid ? 0 : 1
        count += this.$v.documento.tipoConferencia.$invalid ? 0 : 1
        count += this.$v.documento.documentoPermanente.$invalid ? 0 : 1

        return Math.floor(count / max * 100)
      },
      progessColor (state) {
        var max = 1
        var count = 0
        count += this.$v.processo.complementoSetor.$invalid ? 0 : 1

        if (count / max * 100 !== 100) {
          return {
            success: 'bg-danger',
            warning: 'bg-danger'
          }
        }

        return {
          success: 'bg-success',
          warning: 'bg-warning'
        }
      },
      tiposProtocolo () {
        const tiposProtocolo = []

        if (!this.processo) {
          return tiposProtocolo
        }

        if (!(this.tipoPersistencia === EDICAO && this.tipoProtocoloEdicao === 'PROCESSO')) {
          tiposProtocolo.push({
            value: 'Documento Avulso',
            key: 'DOCUMENTO_AVULSO'
          })
        }

        const { PROTOCOLO_TIPO_PROCESSO } = rules
        if (componentIsVisible(PROTOCOLO_TIPO_PROCESSO)) {
          tiposProtocolo.push({
            value: 'Processo',
            key: 'PROCESSO'
          })
        }
        return tiposProtocolo
      },
      assunto: (state) => state.processoCadastro.assunto,
      documentoCadastro: (state) => state.documentoCadastro,
      documentoParams (state) {
        const documentoCadastro = state.documentoCadastro
        const cidadeChave = documentoCadastro.cidadeChave
        const estadoChave = documentoCadastro.estadoChave
        const paisChave = documentoCadastro.paisChave
        const pais = documentoCadastro.pais

        const params = {
          cidade: { chave: '', key: false, show: true },
          estado: { chave: '', key: false, show: true },
          pais: { chave: '', key: false }
        }

        if (cidadeChave) {
          params.cidade.key = true
        }

        if (estadoChave) {
          params.cidade.key = true
          params.cidade.chave = estadoChave
        }

        if (paisChave) {
          params.estado.key = true
          params.estado.chave = paisChave
        }

        if (pais !== 'Brasil') {
          params.estado.show = false
          params.cidade.show = false
        }

        return params
      }
    })
  },

  watch: {
    documentoParams (newValue) {
      if (!newValue) {
        return
      }

      this.$v.documentoParams.$model = this.documentoParams
    },
    assuntoSelecionado (newValue, oldValue) {
      if (!newValue) {
        return
      }

      if (newValue.assunto !== oldValue.assunto) {
        this.$v.processo.assunto.$model = newValue
      }
    },
    codigoAssuntoSelecionado (newValue, oldValue) {
      if (!newValue) {
        return
      }

      if (newValue.codigoAssunto !== oldValue.codigoAssunto) {
        this.$v.processo.assunto.codigoAssunto.$model = newValue
      }
    },
    especieSelecionada (newValue, oldValue) {
      if (!newValue) {
        return
      }

      if (newValue.especie !== oldValue.especie) {
        this.$v.processo.especie.$model = newValue
      }
    },
    codigoEspecieSelecionada (newValue, oldValue) {
      if (!newValue) {
        return
      }

      if (newValue !== oldValue) {
        this.processo.idEspecie = newValue
      }
    },
    interessadosSelecionados (newValue, oldValue) {
      let nomesInteressados = ''
      const interessados = newValue

      this.processo.interessados = interessados

      for (let i = 0; i < interessados.length; i++) {
        nomesInteressados += interessados[i].nome + ', '
      }

      nomesInteressados = nomesInteressados.substring(0, nomesInteressados.length - 2)

      this.$v.interessadosResumo.$model = nomesInteressados
    }
  },

  mounted () {
    eventBus.$on(this.eventBusModal, () => {
      this.closeModal()
    })
  },

  destroyed () {
    eventBus.$off(this.eventBusModal)
    this.$store.commit('MUT_ADD_CONTATO_INTERESSADO', [])
    this.$store.commit('MUT_ESPECIE', {})
    this.$store.commit('MUT_ASSUNTO', {})
    this.$store.commit('MUT_PROCESSO_CADASTRO', {})
    this.$store.commit('MUT_DOCMENTO', {
      cidadeChave: '',
      estadoChave: '',
      paisChave: '001000000000000000000000',
      pais: 'Brasil'
    })
    this.limparDadosProcesso()
  },

  methods: {
    validateRequired (value) {
      if (!this.isNovo) {
        return true
      }

      if (value === '' || !value) {
        return false
      }

      return true
    },

    listarContatos () {
      this.$router.push({ name: 'consultarContatoExterno' })
    },

    setarCamposNumeracao (numeroObj) {
      const dataCriacao = new Date(numeroObj.dataCriacao)

      this.dataCriacao = dataCriacao.toLocaleDateString()
      this.horaCriacao = dataCriacao.toLocaleTimeString()
      this.numeroProcesso = numeroObj.numeroProcessoFormatado
    },

    buscarTiposProcessos () {
      this.dadosFixosService.buscarTiposProcessos().then((data) => {
        this.tipoProcesso = data
      }).catch(err => {
        console.log(err)
      })
    },

    buscarTiposConferencia () {
      this.recursoService.getTipoConferencia({
        idOrgao: this.$store.getters.getDadosSessao.sessao.idOrgao
      }).then((data) => {
        this.tiposConferencia = data.data
      }).catch(err => {
        console.log(err)
      })
    },

    __normalizarNumeroDeAnexos (numeroDeAnexos) {
      return numeroDeAnexos || 0
    },

    onChangeNumeroDeAnexos () {
      const numeroAnexosNormalizado = this.__normalizarNumeroDeAnexos(this.processo.numeroAnexos)
      Object.assign(this.processo, { ...this.processo, numeroDeAnexos: numeroAnexosNormalizado })
      this.$store.commit('MUT_PROCESSO_CADASTRO', { ...this.processo, numeroAnexos: numeroAnexosNormalizado })
    },

    onChangeTipoDocumental () {
      this.$store.commit('MUT_ASSUNTO', {})
      this.$store.commit('MUT_IDASSUNTO', {})
    },

    onChangeTipoProtocolo () {
      this.processo.numeroProcesso.tipoProtocolo = this.tipoProtocolo
      this.saveStateData(this.processo)
    },

    onChangeProcesso () {
      this.processo.numeroAnexos = this.__normalizarNumeroDeAnexos(this.processo.numeroAnexos)
      this.saveStateData(this.processo)
    },

    saveStateData (values) {
      Object.assign(this.processo, { ...values })
      this.$store.commit('MUT_PROCESSO_CADASTRO', values)
    },

    closeModal () {
      const interessados = this.$store.getters.getInteressadosSelecionado
      this.processo.interessados = interessados
      this.criarResumoInteressados(interessados)
    },

    criarResumoInteressados (interessados) {
      let nomesInteressados = ''
      for (var i = 0; i < interessados.length; i++) {
        nomesInteressados += interessados[i].nome + ', '
      }

      this.$v.interessadosResumo.$model = nomesInteressados.substring(0, nomesInteressados.length - 2)
    },

    prepareDocumento () {
      const documento = {
        ...this.documento,
        ...this.documentoCadastro
      }

      this.$store.commit('MUT_DOCMENTO', documento)
    },

    salvar () {
      this.$v.$touch()
      if (this.$v.$invalid) {
        return
      }

      this.prepareDocumento()

      persistirProcesso(this.tipoPersistencia).then((processo) => {
        var numeroProcesso = processo.numeroProcesso.numeroProcessoFormatado
        this.$store.commit('MUT_COMPONENT_VISIBLE_PROPS', {
          editarProtocolo: true,
          volume: processo.numeroProcesso.tipoProtocolo === 'PROCESSO',
          protocoloTipoProcesso: processo.numeroProcesso.tipoProtocolo === 'PROCESSO'
        })

        if (this.isTramitado) {
          this.$store.commit('MUT_COMPONENT_VISIBLE_PROPS', { editarProtocolo: processo.numeroProcesso.tipoProtocolo === 'PROCESSO' })
          this.$router.push({
            name: 'visualizadorProcesso',
            query: {
              disableMenuProcesso: true,
              numeroProcesso: numeroProcesso,
              anableButtonEditar: processo.numeroProcesso.tipoProtocolo === 'PROCESSO',
              tramitado: true
            }
          })
          return
        }

        this.$router.push({ name: 'visualizadorProcesso', query: { numeroProcesso } })
      }).catch((error) => {
        this.updateAlert('danger', error.message)
      })
    },

    updateAlert (type, menssage) {
      this.alert = {
        type: type,
        texto: menssage,
        key: !this.alert.key
      }
    },

    voltar () {
      this.$router.back()
    },

    limparDadosProcesso () {
      this.processo.id = ''
      this.processo.tipoProcesso = ''
      this.processo.sigiloso = 'NAO'
      this.processo.complementoSetor = ''
      this.processo.usuarioCriacao = ''
      this.processo.nomeUsuario = ''
      this.processo.idOrgao = ''
      this.processo.siglaOrgao = ''
      this.processo.idDepartamento = ''
      this.processo.siglaDepartamento = ''
      this.processo.codigoHierarquia = ''
      this.processo.estado = ''
      this.processo.cidade = ''
      this.processo.numeroProcesso = {}
      this.processo.assunto = {}
      this.processo.especie = {}
      this.processo.interessados = null
      this.processo.numeroAnexos = '0'

      this.saveStateData(this.processo)
    },

    configurarProcesso (processo) {
      this.processo = processo
      this.saveStateData(processo)

      if (this.tipoPersistencia !== NOVO) {
        if (this.tipoPersistencia === MODELO) {
          this.numeroProcesso = ''
        } else {
          this.setarCamposNumeracao(processo.numeroProcesso)
        }

        this.tipoProtocolo = processo.tipoProtocolo || processo.numeroProcesso.tipoProtocolo

        if ([EDICAO, MODELO].includes(this.tipoPersistencia)) {
          this.$store.commit('MUT_ADD_CONTATO_INTERESSADO', processo.interessados)
          this.criarResumoInteressados(processo.interessados)
        }
      }
    },

    formatarProtocolo (protocolo) {
      return protocoloParse(protocolo).value
    }
  }
}
</script>

<style scoped lang="scss">
.acoes {
  display: flex;
  padding: 15px;
  position: absolute;

  .btn {
    margin-right: 10px;
    width: 150px;
    height: 28px;
  }
}

#dadosElaboracaoProcesso div {
  padding-bottom: 2px;
  padding-top: 2px;

  .btnInteressados {
    padding: 3px 18px;
    border-radius: 4px;
  }
}

.btn {
  //padding: 8px 16px;
  border-radius: 5px;

  &--primary {
    background-color: green;
    color: #fff;
  }

  &--secondary {
    background-color: #dddd;
    color: #000;
  }
}

.interesadoResumidos {
  background-color: white;
}

.interessadosHeader {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-direction: row;
  padding: .75rem;
  background-color: rgba(213, 228, 251, 1);

  .titulo {
    color: #0962BD;
    margin: 10px;
  }

  i {
    color: red;
  }
}

.interessadosFooter {
  display: flex;
  justify-content: flex-end;

  .btn {
    margin-left: 5px;
    margin-right: 10px;
  }
}

.overflow-hidden {
  overflow: hidden;
}

.erro {
  color: orange;
}
</style>
